export default __webpack_public_path__ + "static/open-7bbb264728aa46a71ed3a24e509e8e71.png";